export default (storeState, { payload }) => {
  let newState = Object.assign({}, storeState);

  newState.settingsAdvance = payload

  return newState;
};
